import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onAddCategoryRes } from "./helper";

const addCategory = async (data: CategoryReqT) =>
  axios.post(Routes.ADD_CATEGORY, data);

export const useAddCategory = () =>
  useMutation({
    mutationKey: [Keys.ADD_CATEGORY_MUT],
    mutationFn: addCategory,
    onSuccess: onAddCategoryRes,
  });
